export function parseVersion(value){
  const raw=String(value||'').trim().replace(/^v/i,'');
  const [coreRaw,...preParts]=raw.split('-');
  const core=coreRaw.split('.').map(part=>Number(part)||0);
  while(core.length<3)core.push(0);
  const pre=preParts.join('-');
  return {raw,core:core.slice(0,3),pre:pre?pre.split(/[.-]/).filter(Boolean):[]};
}

function compareIdentifiers(a,b){
  const an=/^\d+$/.test(a),bn=/^\d+$/.test(b);
  if(an&&bn)return Number(a)-Number(b);
  if(an&&!bn)return -1;
  if(!an&&bn)return 1;
  return a===b?0:(a>b?1:-1);
}

export function compareVersions(left,right){
  const a=parseVersion(left),b=parseVersion(right);
  for(let i=0;i<3;i++)if(a.core[i]!==b.core[i])return a.core[i]>b.core[i]?1:-1;
  if(!a.pre.length&&!b.pre.length)return 0;
  if(!a.pre.length)return 1;
  if(!b.pre.length)return -1;
  const count=Math.max(a.pre.length,b.pre.length);
  for(let i=0;i<count;i++){
    if(a.pre[i]===undefined)return -1;
    if(b.pre[i]===undefined)return 1;
    const diff=compareIdentifiers(a.pre[i],b.pre[i]);
    if(diff)return diff>0?1:-1;
  }
  return 0;
}

export function updateState(current,manifest){
  if(!manifest)return Object.freeze({available:false,mandatory:false,current,latest:null,minimum:null});
  const latest=String(manifest.latestVersion||current),minimum=String(manifest.minimumSupportedVersion||'0.0.0');
  return Object.freeze({available:compareVersions(latest,current)>0,mandatory:compareVersions(current,minimum)<0,current,latest,minimum});
}
